/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/** @jsxImportSource @emotion/react */
import React, { useContext, useState, useEffect, ReactNode } from 'react';
import { ThemeContext } from '../../config/theme';
import CloseButton from '../components/CloseButton/CloseButton';
import themedStyles from './SidebarModal.css';

type Props = {
  // eslint-disable-next-line no-undef
  children: ReactNode | ReactNode[];
  onClose: () => void;
};

export default function SidebarModal({ children, onClose }: Props) {
  const [showModal, setShowModal] = useState(false);
  const styling = themedStyles(useContext(ThemeContext));
  useEffect(() => setShowModal(true), []);

  const closeModal = () => {
    setShowModal(false);
    setTimeout(onClose, 300);
  };

  return (
    <>
      <div
        css={[styling.blurOverlay, showModal ? styling.showBlurOverlay : styling.hideBlurOverlay]}
        onClick={closeModal}
      />
      <div css={[styling.modal, showModal ? styling.showSidebar : styling.hideSidebar]}>
        <div css={styling.header}>
          <CloseButton onClick={closeModal} />
        </div>
        <div css={styling.modalContent}>{children}</div>
      </div>
    </>
  );
}
